import { Colors } from './types';
import { globalSystemColors } from './constants';

const white = '#fff';
const lightGrey = '#eae5e1';

export const lightColors: Colors = {
  text: {
    primary: '#2f1f19',
    secondary: '#98918a',
    basic: '#505050',
    platinum: '#7a66de',
    silver: '#888686',
    gold: '#9c8651',
    white: '#fefefe',
    tertiary: '#bcbcbc'
  },
  background: {
    primary: white,
    secondary: '#f6f4f1',
    tertiary: '#f8f8f8',
    footer: '#f8f8f8'
  },
  border: {
    primary: lightGrey,
    primaryReverse: '#1b1b1d',
    secondary: '#eaeaea'
  },
  loginButton: {
    bg: white,
    border: lightGrey,
    hoveredBorder: lightGrey
  },
  systemColors: {
    ...globalSystemColors,
    brand: '#946952',
    lightBlue: '#dae8ff',
    lightRed: '#ffe6e5',
    autumnRed: '#d93d04'
  },
  promotion: {
    bump: '#78c91d',
    vip: '#ff3d00',
    premium: '#ff9f2b'
  }
};
